module.exports = __webpack_public_path__ + "img/aston-villa.9651d1f9.png";